import { cn } from "@/lib/utils";

interface ChevronProps {
  className?: string;
  pulse?: boolean;
}

/**
 * The PTRN chevron motif — a terminal-prompt-style `⟩` that marks
 * brand, breadcrumbs, and agent action moments. `pulse=true` adds a
 * gentle opacity animation to telegraph "agent is thinking".
 *
 * Used freely in headers, list bullets, status lines. Don't overload
 * it; one per logical section is the rhythm.
 */
export function Chevron({ className, pulse = false }: ChevronProps) {
  return (
    <span
      className={cn(pulse ? "ptrn-chevron-pulse" : "ptrn-chevron", className)}
      aria-hidden="true"
    >
      ⟩
    </span>
  );
}
